module.exports = "pegasus/assets/blocks/header-8-tech.png";